﻿import { api } from '@cwd/lib/main';

export interface Group {
    GroupId: string;
    Name: string;
    UserCount: number;
    ObjectCount: number;
    Users?: GroupUserReference[];
}

export interface SaveGroup {
    name: string;
    groupId?: string;
}

export interface GroupUserReference {
    UserId: string;
    FirstName: string;
    LastName: string;
    Name: string;
    UserName: string;
    Email?: string;
}

export const getGroups = (): Promise<Group[]> => api.get('/Groups');
export const getUsersInGroups = (groupId: string): Promise<GroupUserReference[]> => api.get(`/Groups/${groupId}/Users`);
export const addUserToGroup = (groupId: string, userId: string): Promise<void> => api.post(`/Groups/${groupId}/Add/${userId}`);
export const removeUserFromGroup = (groupId: string, userId: string): Promise<void> => api.post(`/Groups/${groupId}/Remove/${userId}`);
export const saveGroup = (group: SaveGroup): Promise<string> => api.post('/Groups', group);
export const deleteGroup = (groupId: string): Promise<void> => api.delete(`/Groups/${groupId}`);
export const getUsersToAddToGroups = (): Promise<GroupUserReference[]> => api.get(`/Users?$orderby=Email`);
